<div
  class="buttons d-print-none"
  *ngIf="version && version.status === 0 && !version.approvedOn"
>
  <div class="row">
    <div class="col-6">
      <button
        type="button"
        mat-flat-button
        *ngIf="hasPrivilege(privilegeEnum.CreateABSITemplate)"
        color="warn"
        (click)="this.canceled.emit(true)"
      >
        Delete
      </button>
    </div>
    <div class="col-6 d-flex justify-content-end">
      <button
        type="button"
        mat-flat-button
        *ngIf="
          hasPrivilege(privilegeEnum.ApproveABSITemplate) &&
          (version.updatedBy ?? version.createdBy) != currentUser?.id
        "
        color="primary"
        [disabled]="disabled"
        (click)="this.approved.emit(true)"
      >
        Approve
      </button>
    </div>
  </div>
</div>
